import { render, staticRenderFns } from "./view-homepage.vue?vue&type=template&id=dc275a80&"
import script from "./view-homepage.vue?vue&type=script&lang=js&"
export * from "./view-homepage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports